import { createContext, useContext } from 'react';

/** Returns true when the active settings panel has unsaved changes. */
export type UnsavedGuard = () => boolean;

export interface SettingsUnsavedChangesContextValue {
  /**
   * Register (or clear, with `null`) the active panel's unsaved-changes check.
   * Only one panel is mounted at a time, so a single guard slot is sufficient.
   */
  registerGuard: (guard: UnsavedGuard | null) => void;
  /**
   * Run `proceed` immediately if there are no unsaved changes; otherwise open
   * the discard confirmation and defer `proceed` until the user confirms.
   */
  confirmNavigation: (proceed: () => void) => void;
}

// Default is a no-op passthrough so SettingsTabBar works even if rendered
// outside the provider (navigation just proceeds, matching prior behavior).
export const SettingsUnsavedChangesContext =
  createContext<SettingsUnsavedChangesContextValue>({
    registerGuard: () => {},
    confirmNavigation: proceed => proceed(),
  });

export function useSettingsUnsavedChanges(): SettingsUnsavedChangesContextValue {
  return useContext(SettingsUnsavedChangesContext);
}
